import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import layout from '@/layout'
/* Layout */
export const constantRoutes = [
  {
    path: '/index',
    component: () => import('@/views/index/index'),
    meta: { hidden: true, title: '鞍山市中医院' }
  },
  {
    path: '/chufang',
    component: () => import('@/views/fasleLoding/chufang'),
    hidden: true
  },
  {
    path: '/guahao',
    component: () => import('@/views/fasleLoding/guahao'),
    hidden: true
  },
  {
    path: '/appointment',
    component: layout,
    children: [
      {
        path: '/selectRoom',
        name: 'selectRoom',
        component: () => import('@/views/appointment/selectRoom'),
        meta: { hidden: true, title: '选择诊室' }
      },
      {
        path: '/selectDoctor',
        name: 'selectDoctor',
        component: () => import('@/views/appointment/selectDoctor'),
        meta: { hidden: true, title: '选择医生' }
      },
      {
        path: '/selectDepartment',
        name: 'selectDepartment',
        component: () => import('@/views/appointment/selectDepartment'),
        meta: { hidden: true, title: '选择科室' }
      },
      {
        path: '/payDetail',
        name: 'payDetail',
        component: () => import('@/views/appointment/payDetail'),
        meta: { hidden: true, title: '付款详情' }
      },
      {
        path: '/searchResult',
        name: 'searchResult',
        component: () => import('@/views/appointment/searchResult'),
        meta: { hidden: true, title: '搜索结果' }
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/appointment/register'),
        meta: { hidden: true, title: '挂号' }
      },
      {
        path: '/goPay',
        name: 'goPay',
        component: () => import('@/views/appointment/goPay'),
        meta: { hidden: true, title: '订单支付' }
      },
      {
        path: '/payResult',
        name: 'payResult',
        component: () => import('@/views/appointment/payResult'),
        meta: { hidden: true, title: '付款结果' }
      }
    ],
    hidden: true
  },
  {
    path: '/doctor',
    component: layout,
    children: [
      {
        path: '/doctorDetail',
        name: 'doctorDetail',
        component: () => import('@/views/doctor/doctorDetail'),
        meta: { hidden: true, title: '医生详情' }
      },
      {
        path: '/doctorFollowList',
        name: 'doctorFollowList',
        component: () => import('@/views/doctor/doctorFollowList'),
        meta: { hidden: true, title: '关注列表' }
      }
    ],
    hidden: true
  },
  {
    path: '/index',
    component: layout,
    children: [
      {
        path: '/index2',
        name: 'index2',
        component: () => import('@/views/index/index2'),
        meta: { hidden: true, title: '' }
      }
    ],
    hidden: true
  },
  {
    path: '/pay',
    component: layout,
    children: [
      {
        path: '/payList',
        name: 'payList',
        component: () => import('@/views/pay/payList'),
        meta: { hidden: true, title: '挂号单' }
      },
      {
        path: '/billDetail',
        name: 'billDetail',
        component: () => import('@/views/pay/billDetail'),
        meta: { hidden: true, title: '挂号记录' }
      }
    ],
    hidden: true
  },
  {
    path: '/map',
    component: layout,
    children: [
      {
        path: '/mapNavigation',
        name: 'mapNavigation',
        component: () => import('@/views/map/mapNavigation'),
        meta: { hidden: true, title: '来院导航' }
      }
    ],
    hidden: true
  },
  {
    path: '/docList',
    component: layout,
    children: [
      {
        path: '/docindex',
        name: 'docindex',
        component: () => import('@/views/docList/docindex'),
        meta: { hidden: true, title: '医生列表' }
      }
    ],
    hidden: true
  },
  {
    path: '/login',
    component: layout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/index/login'),
        meta: { hidden: true, title: '登录中' }
      }
    ],
    hidden: true
  },
  {
    path: '/my',
    component: layout,
    children: [
      {
        path: '/my',
        name: 'mapNavigation',
        component: () => import('@/views/my/my'),
        meta: { hidden: true, title: '个人中心' }
      }
    ],
    hidden: true
  },
  {
    path: '/prevention',
    component: layout,
    children: [
      {
        path: '/preventionIndex',
        name: 'preventionIndex',
        component: () => import('@/views/prevention/preventionIndex'),
        meta: { hidden: true, title: '预约体检' }
      },
      {
        path: '/confirmData',
        name: 'confirmData',
        component: () => import('@/views/prevention/confirmData'),
        meta: { hidden: true, title: '确认预约信息' }
      },
      {
        path: '/goPrevention',
        name: 'goPrevention',
        component: () => import('@/views/prevention/goPrevention'),
        meta: { hidden: true, title: '预约体检' }
      }
    ],
    hidden: true
  },
  {
    path: '/lookReport',
    component: layout,
    children: [
      {
        path: '/certification',
        name: 'certification',
        component: () => import('@/views/lookReport/certification'),
        meta: { hidden: true, title: '人脸识别' }
      },
      {
        path: '/reportIndex',
        name: 'reportIndex',
        component: () => import('@/views/lookReport/reportIndex'),
        meta: { hidden: true, title: '门诊报告' }
      },
      {
        path: '/reportList',
        name: 'reportList',
        component: () => import('@/views/lookReport/reportList'),
        meta: { hidden: true, title: '门诊报告' }
      }
    ],
    hidden: true
  },
  {
    path: '/patient',
    component: layout,
    children: [
      {
        path: '/addPatient',
        name: 'addPatient',
        component: () => import('@/views/patient/addPatient'),
        meta: { hidden: true, title: '添加就诊人' }
      },
      {
        path: '/addPatientForm',
        name: 'addPatientForm',
        component: () => import('@/views/patient/addPatientForm'),
        meta: { hidden: true, title: '添加就诊人' }
      },
      {
        path: '/patientCode',
        name: 'patientCode',
        component: () => import('@/views/patient/patientCode'),
        meta: { hidden: true, title: '二维码' }
      },
      {
        path: '/patientList',
        name: 'patientList',
        component: () => import('@/views/patient/patientList'),
        meta: { hidden: true, title: '就诊人管理' }
      },
      {
        path: '/changePatient',
        name: 'changePatient',
        component: () => import('@/views/patient/changePatient'),
        meta: { hidden: true, title: '修改信息' }
      },
      {
        path: '/seeadoctor',
        name: 'seeadoctor',
        component: () => import('@/views/patient/seeadoctor'),
        meta: { hidden: true, title: '就诊卡明细' }
      },
      {
        path: '/bindPatient',
        name: 'bindPatient',
        component: () => import('@/views/patient/bindPatient'),
        meta: { hidden: true, title: '新建就诊卡' }
      }
    ],
    hidden: true
  },
  {
    path: '/prescription',
    component: layout,
    children: [
      {
        path: '/list',
        name: 'list',
        component: () => import('@/views/prescription/list'),
        meta: { hidden: true, title: '门诊缴费列表' }
      },
      {
        path: '/selectpre',
        name: 'selectpre',
        component: () => import('@/views/prescription/selectpre'),
        meta: { hidden: true, title: '处方列表' }
      },
      {
        path: '/createOrder',
        name: 'createOrder',
        component: () => import('@/views/prescription/createOrder'),
        meta: { hidden: true, title: '创建订单' }
      }
    ],
    hidden: true
  },
  {
    path: '/nucleicAcid',
    component: layout,
    children: [
      {
        path: '/questionnaire',
        name: 'questionnaire',
        component: () => import('@/views/nucleicAcid/questionnaire'),
        meta: { hidden: true, title: '问卷调查' }
      },
      {
        path: '/nindex',
        name: 'nindex',
        component: () => import('@/views/nucleicAcid/nindex'),
        meta: { hidden: true, title: '核酸检验' }
      },
      {
        path: '/acidpay',
        name: 'acidpay',
        component: () => import('@/views/nucleicAcid/acidpay'),
        meta: { hidden: true, title: '核酸检验' }
      },
      {
        path: '/acidList',
        name: 'acidList',
        component: () => import('@/views/nucleicAcid/acidList'),
        meta: { hidden: true, title: '核酸缴费' }
      },
      {
        path: '/result',
        name: 'result',
        component: () => import('@/views/nucleicAcid/result'),
        meta: { hidden: true, title: '核酸结果' }
      },
      {
        path: '/barcode',
        name: 'barcode',
        component: () => import('@/views/nucleicAcid/barcode'),
        meta: { hidden: true, title: '核酸详情' }
      }
    ],
    hidden: true
  },

  {
    path: '/hospitalInfo',
    component: layout,
    children: [
      {
        path: '/details',
        name: 'details',
        component: () => import('@/views/hospitalInfo/details'),
        meta: { hidden: true, title: '详情' }
      },
      {
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/hospitalInfo/guide'),
        meta: { hidden: true, title: '指南' }
      }
    ],
    hidden: true
  },
  {
    path: '/result',
    component: layout,
    children: [
      {
        path: '/resultPacsList',
        name: 'resultPacsList',
        component: () => import('@/views/result/resultPacsList'),
        meta: { hidden: true, title: '检查列表' }
      },
      {
        path: '/resultLisList',
        name: 'resultLisList',
        component: () => import('@/views/result/resultLisList'),
        meta: { hidden: true, title: '检验列表' }
      },
      {
        path: '/resultPacs',
        name: 'resultPacs',
        component: () => import('@/views/result/resultPacs'),
        meta: { hidden: true, title: '检查详情' }
      },
      {
        path: '/resultLis',
        name: 'resultLis',
        component: () => import('@/views/result/resultLis'),
        meta: { hidden: true, title: '检验详情' }
      },
    ],
    hidden: true
  },
  {
    path: '/loading',
    component: layout,
    children: [
      {
        path: '/no',
        name: 'no',
        component: () => import('@/views/loading/no'),
        meta: { hidden: true, title: '开发中' }
      }
    ],
    hidden: true
  },
  {
    path: '/aliPayIndex',
    name: 'aliPayIndex',
    component: () => import('@/views/alipay/alipay'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/index/index'),
    hidden: true
  }
]

const createRouter = () =>
  new Router({
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
